import { produce } from 'immer'
import { deactivateBudgetRouteProps } from 'src/navigation/routeProps'
import {
  DEACTIVATE_CREDIT_CARD_FAILURE,
  DEACTIVATE_CREDIT_CARD_INIT,
  DEACTIVATE_CREDIT_CARD_SUCCESS,
  DeactivateCreditCardActions,
} from 'src/redux/actions/data/creditCards.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap } from 'src/utils/error.utils'

export interface DeactivateBudgetState {
  deletingCreditCard: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: DeactivateBudgetState = {
  deletingCreditCard: false,
}

export type Actions = DeactivateCreditCardActions

const CoreDeactivateBudgetReducer = (
  state = initialState,
  action: Actions,
): DeactivateBudgetState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case DEACTIVATE_CREDIT_CARD_INIT: {
        draft.deletingCreditCard = true
        return draft
      }

      case DEACTIVATE_CREDIT_CARD_FAILURE: {
        draft.deletingCreditCard = false
        return draft
      }

      case DEACTIVATE_CREDIT_CARD_SUCCESS: {
        draft.deletingCreditCard = false
        return draft
      }
    }
  })
}

const DeactivateBudgetReducer = createFlyoutReducer(
  deactivateBudgetRouteProps,
  initialState,
  CoreDeactivateBudgetReducer,
)

export default DeactivateBudgetReducer
